import { useRef, useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import { Upload, FileText, Loader2 } from "lucide-react";
import { Panel, Btn, Th, Td, RT } from "./ui";

export default function SectionAttachments({ rep, canEdit, onChanged }) {
  const fileRef = useRef();
  const [desc, setDesc] = useState("");
  const [busy, setBusy] = useState(false);
  const upload = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    try {
      const fd = new FormData();
      [...files].forEach((f) => fd.append("files", f));
      fd.append("description", desc);
      await client.post(`/rms-reports/${rep.id}/attachments`, fd);
      toast.success("Attachment(s) uploaded"); setDesc(""); onChanged();
    } catch (e) { toast.error(e.response?.data?.detail || "Upload failed"); }
    setBusy(false);
  };
  const open = async (a) => {
    try {
      const r = await client.get(`/rms-reports/attachment/${a.path}`, { responseType: "blob" });
      window.open(URL.createObjectURL(r.data), "_blank");
    } catch { toast.error("Unable to open attachment"); }
  };
  const rows = rep.attachments || [];
  return (
    <Panel title={`Attachments (${rows.length})`} testid="panel-attachments"
      right={canEdit && (
        <div className="flex items-center gap-2">
          <input value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Description"
            data-testid="attach-desc" className="bg-white border-2 px-2 py-0.5 text-[11px] font-mono rounded-sm w-40 placeholder:text-[#5b6c7a]"
            style={{ borderColor: "#7da7c7", color: RT.text }} />
          <Btn small onClick={() => fileRef.current?.click()} disabled={busy} testid="attach-upload-btn">
            {busy ? <Loader2 size={11} className="animate-spin" /> : <Upload size={11} />} Upload
          </Btn>
          <input ref={fileRef} type="file" multiple accept=".jpg,.jpeg,.png,.webp,.heic,.heif,.pdf" className="hidden"
            onChange={(e) => upload(e.target.files)} data-testid="attach-file-input" />
        </div>
      )}>
      {rows.length === 0 ? (
        <div className="font-mono text-[11px] py-3 text-center" style={{ color: RT.dim }}>NO ATTACHMENTS — photographs, video, audio, PDFs, statements & supporting documents attach here.</div>
      ) : (
        <table className="w-full">
          <thead><tr><Th>FILE</Th><Th>TYPE</Th><Th>DESCRIPTION</Th><Th>UPLOADED BY</Th><Th>DATE/TIME</Th><Th>INTEGRITY (SHA-256)</Th></tr></thead>
          <tbody>{rows.map((a, i) => (
            <tr key={i} data-testid={`attach-row-${i}`}>
              <Td><button onClick={() => open(a)} className="flex items-center gap-1 text-[#1d5d90] underline" data-testid={`attach-open-${i}`}>
                <FileText size={12} /> {a.filename}</button></Td>
              <Td>{a.content_type}</Td><Td mono={false}>{a.description || "—"}</Td>
              <Td>{a.uploaded_by}</Td><Td>{a.ts?.slice(0, 16)}</Td><Td>{(a.sha256 || "").slice(0, 16)}…</Td>
            </tr>))}
          </tbody>
        </table>
      )}
    </Panel>
  );
}
